import { jsx as _jsx } from "react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { useStaticQuery } from 'gatsby';
var query = "1003640200";
export default (function (_ref) {
    var _ref$description = _ref.description, description = _ref$description === void 0 ? '' : _ref$description, _ref$lang = _ref.lang, lang = _ref$lang === void 0 ? 'en' : _ref$lang, _ref$meta = _ref.meta, meta = _ref$meta === void 0 ? [] : _ref$meta, title = _ref.title;
    var _useStaticQuery = useStaticQuery(query), site = _useStaticQuery.site;
    return /*#__PURE__*/ _jsx(Helmet, {
        htmlAttributes: {
            lang: lang
        },
        title: title,
        titleTemplate: "%s | " + site.siteMetadata.title,
        meta: [{
                name: "description",
                content: description || site.siteMetadata.description
            }, {
                property: "og:title",
                content: title
            }, {
                property: "og:description",
                content: description || site.siteMetadata.description
            }, {
                property: "og:type",
                content: "website"
            }, {
                name: "twitter:card",
                content: "summary"
            }, {
                name: "twitter:creator",
                content: site.siteMetadata.author
            }, {
                name: "twitter:title",
                content: title
            }, {
                name: "twitter:description",
                content: description || site.siteMetadata.description
            }].concat(meta)
    });
});
